<template>
  <div class="app" id="scroll" @scroll="scroll">
    <el-container>
      <Header page="" :style="{ background: hasScroll ? '#444' : '' }" />
      <el-main class="main">
        <!-- <div class="holder"></div> -->
        <router-view />
        <el-backtop target=".app" :visibility-height="100"></el-backtop>
      </el-main>
      <el-footer>
        <Footer />
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import Header from '@/views/Layout/header'
import Footer from '@/views/Layout/footer'

export default {
  name: 'App',

  mixins: [],

  components: {
    Header,
    Footer,
  },

  props: {},

  data() {
    return {
      hasScroll: false,
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    scroll() {
      const scroll = document.getElementById('scroll')
      if (scroll.scrollTop > 5) {
        this.hasScroll = true
      } else {
        this.hasScroll = false
      }
    },
  },
}
</script>

<style lang="less">
html,
body {
  margin: 0;
  padding: 0;
  font-family: '微软雅黑', Arial, 'PingFang SC';
  background: #eff0f1;
  font-weight: 400;
  min-width: 350px;
  height: 100vh;
}

.app {
  position: relative;
  height: 100vh;
  overflow-x: hidden;

  .el-main {
    padding: 0;
    position: relative;
    z-index: 9;
  }

  .el-footer {
    height: auto !important;
    padding: 0;
  }
}

@media screen and (max-width: 768px) {
  .holder {
    height: 70px !important;
  }
}

.holder {
  background: rgba(68, 68, 68, 0);
  height: 80px;
}
</style>
